import type { MetricItemDTO } from '@/types/agentEvents';
import type {
  ExportMetricsCsvArgs,
  MetricsCsvColumn,
} from '@/utils/metricsCsvExport';
import { exportMetricsCsv } from '@/utils/metricsCsvExport';
import { Button } from '@gapartners/ui';
import { useTranslation } from 'react-i18next';

export function ExportCsvButton({
  metric,
  rows,
  groupingKey,
  intervalPeriod,
  startTime,
  endTime,
  columns,
  filenameParts,
}: Omit<ExportMetricsCsvArgs, 'rows' | 'columns'> & {
  rows?: MetricItemDTO[];
  columns?: MetricsCsvColumn[];
}) {
  const { t } = useTranslation();

  const canExport = Boolean(rows && rows.length > 0);

  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={() => {
        if (!rows) return;
        exportMetricsCsv({
          metric,
          rows,
          groupingKey,
          intervalPeriod,
          startTime,
          endTime,
          columns,
          filenameParts,
        });
      }}
      disabled={!canExport}
    >
      {t('components.dashboard.exportCsv')}
    </Button>
  );
}
